export default __webpack_public_path__ + "static/media/horn_one.5411a76c.mp3";